import SimpleBar from 'simplebar';
import BaseComponent from './BaseComponent';
import App from "../Core/App";

export default class BlogArchiveSubnav extends BaseComponent {
    constructor() {
        super();

        let app = App.getInstance();

        if ($('#blog-archive-subnav').length === 0) {
            this._exists = false;
            return;
        }
        
        this._exists = true;
        this.blogArchiveScrollbar = new SimpleBar($('#blog-archive-subnav .blb-box-content-wrapper')[0], { autoHide: false });
    }

    exists() {
        return this._exists;
    }

    _onResize() {
        this.exists() && this.blogArchiveScrollbar.recalculate();
    }
}